import React from "react";
import { observable, action, decorate } from "mobx";
import { observer } from "mobx-react";
import {
  InputAdornment,
  OutlinedInput,
  FormControl,
  InputLabel,
  Checkbox,
  Button,
  Tooltip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { MdArrowDropDown } from "react-icons/md";
import styled from "styled-components";

import COLORS from "scss/colors.module.scss";
import Menu from "./Menu";

class SelectMultiLevel extends React.Component {
  anchorElement = null;
  value = "";

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.labelRef = React.createRef();
  }

  handleButtonClick = (event) => {
    this.anchorElement = event.currentTarget;
  };

  handleMenuClose = (ev) => {
    this.anchorElement = null;
  };

  render() {
    let {
      Buttonref = null,
      filterFunction = null,
      anchorOrigin = {},
      transformOrigin = {},
      valueKey,
      displayKey,
      disabled = false,
      onChange,
      value = {},
      values,
      tooltip = "",
      label = "",
      isLoading = false,
      isAddColumnLookupPopup = false,
      forDuplication = false,
      forMail = false,
      ...others
    } = this.props;
    let endAdornment = null;

    if (!disabled) {
      endAdornment = (
        <InputAdornment position="end">
          <ExpandMoreIcon onClick={this.handleButtonClick} />
        </InputAdornment>
      );
    }
    const title = value[displayKey] ||
      (typeof value === "string" ? value : "") || <i>{label}</i>;

    return (
      <React.Fragment>
        {/* <FormControl
          variant="outlined"
          {...others}
          // onClick={this.handleButtonClick}
        >
          <InputLabel ref={this.labelRef}> {label} </InputLabel>
          <OutlinedInput
            variant="outlined"
            size="small"
            ref={this.inputRef}
            value={
              value[displayKey] || (typeof value === "string" ? value : "")
            }
            labelWidth={
              this.labelRef && this.labelRef.current
                ? this.labelRef.current.offsetWidth
                : label.length > 0
                ? 50
                : 0
            } //todo check this
            disabled={true}
            // onFocus={this.handleButtonClick}
            endAdornment={endAdornment}
          />
        </FormControl> */}
        <Tooltip title={tooltip}>
          <Button ref={Buttonref} onClick={this.handleButtonClick} fullWidth>
            <StyledLabel>{title}</StyledLabel>
            <MdArrowDropDown size={18} color={COLORS.TEXT_COLOR} />
          </Button>
        </Tooltip>
        {!disabled && (
          <Menu
            open={Boolean(this.anchorElement)}
            menuItems={values}
            anchorElement={this.anchorElement}
            onClose={this.handleMenuClose}
            valueKey={valueKey}
            displayKey={displayKey}
            onMenuItemClick={(menuItem) => {
              this.value = menuItem;
              onChange(menuItem);
              this.handleMenuClose();
            }}
            isLoading={isLoading}
            filterFunction={filterFunction}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            isAddColumnLookupPopup={isAddColumnLookupPopup}
            forDuplication = {forDuplication}
            forMail = {forMail}
          />
        )}
      </React.Fragment>
    );
  }
}

const StyledLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

decorate(SelectMultiLevel, {
  anchorElement: observable,
  value: observable,

  handleButtonClick: action.bound,
  handleMenuClose: action.bound,
});
export default observer(SelectMultiLevel);
